<ol-widget-container [title]="title()">
  <div class="link-widget">
    <div class="link-widget__content">
      <div class="image-container">
        <img class="widget-image" [src]="imageUrl()" alt="Latest drop" />
      </div>

      <div class="text-container">
        <p class="link-widget__description">{{ description() }}</p>

        <a
          [href]="linkUrl()"
          class="community-button primary link-widget__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ linkText() }}
        </a>
      </div>
    </div>
  </div>
</ol-widget-container>
